import Vue from 'vue'
import Vuex from 'vuex'
import permissions from './modules/permissions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userGroups: [],
    userData: {},
    isBigSidebar: true
  },
  mutations: {
    setUserGroups(state, payload) {
      state.userGroups = payload
      localStorage.setItem('userGroups', JSON.stringify(payload))
    },
    setUserData(state, payload) {
      state.userData = payload
    },
    changeSidebarSize(state, payload) {
      state.isBigSidebar = payload
    },
  },
  actions: {},
  modules: { permissions },
})
